module.exports = __webpack_public_path__ + "static/img/200165.aa8b5389.png";